import React from "react";
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HighchartsExporting from 'highcharts/modules/exporting';

const OfflineColumnChart = (props) => {

    const options = {
        title: {
            text: `${props?.title ? props.title : 'Team HWI - antal per resultatkategori'}`,
        },
        xAxis: {
            categories: ['12-24', '25-41', '42-59', '60-72']
        },
        yAxis: {
            min: 0,
            max: props?.totalUsers,
            title: {
                text: "Antal som svarat"
            }
        },
        series: [{
            type: 'column',
            name: 'Antal som svarat',
            colorByPoint: true,
            colors: ['#B23722', '#c35f1c','#E9B90F', '#778441' ],
            data: props?.data,
            showInLegend: false
        }]
    }

    if (typeof Highcharts === 'object') {
        HighchartsExporting(Highcharts)
    }

    return (
        <HighchartsReact
            highcharts={Highcharts}
            options={options}
        />
    )

}

export default OfflineColumnChart;